import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.css']
})
export class ErrorModalComponent {
  @Input() errorMessage = 'error';
  isHidden: boolean;

  constructor() {
    this.isHidden = false;
  }

  closeModal() {
    this.isHidden = true;
  }
}
